
import styled from "styled-components";
import { MainCategoryContainerStyled, CategoryContainerStyled, CategoryHeaderStyled, CategoryHeaderArStyled,  CategorySubHeaderStyled, CategorySubHeaderArStyled, CategoryGridStyled, ItemContainerStyled, ItemImageContainer, ItemBoxTwoStyled, ItemDetailsContainer, ItemDetailsStyled, ItemDetailsArStyled,  ItemPriceContainer, ItemPriceContainerAr, ItemNameStyled, ItemNameArStyled } from "../wcsMenuAspire/generalStyles";

function AddOnsGrid({triggerLanguage}) {
    if(triggerLanguage == "en") {
        return (
            <MainCategoryContainerStyled>
                <CategoryContainerStyled>
                        ADD ONS
                    <ItemContainerStyled>
                        <ItemBoxTwoStyled>
                            <ItemDetailsContainer>
                                <div>
                                    <ItemNameStyled>
                                    EXTRA COFFEE SHOT / 8 QR
                                    </ItemNameStyled>
                                    <ItemDetailsStyled>
                                    DOUBLE THE ENERGY - EXTRA ESPRESSO SHOT AVAILABLE
                                    </ItemDetailsStyled>
                                </div>
                            </ItemDetailsContainer>
                        </ItemBoxTwoStyled>
                    </ItemContainerStyled>
                </CategoryContainerStyled>
            </MainCategoryContainerStyled>
        )
    }

    if(triggerLanguage == "ar") {
        return (
            <MainCategoryContainerStyled>
                <CategoryContainerStyled>
                    <CategoryHeaderArStyled>
                    الإضافات
                    </CategoryHeaderArStyled>
                    <ItemContainerStyled>
                        <ItemBoxTwoStyled>
                            <ItemPriceContainerAr></ItemPriceContainerAr>
                            <ItemDetailsContainer style = {{textAlign: "right"}}>
                                <div>
                                    <ItemNameArStyled>
                                    ﺷﻮت ﻗﻬﻮة اﺿﺎﻓﻴﺔ / ٨ ر.ق 
                                    </ItemNameArStyled>
                                    <ItemDetailsArStyled>
                                    ﺿﻌﻒ اﻟﻄﺎﻗﺔ — ﺟﺮﻋﺔ إﺳﺒﺮﻳﺴﻮ إﺿﺎﻓﻴﺔ ﻣﺘﻮﻓﺮة
                                    </ItemDetailsArStyled>
                                </div>
                            </ItemDetailsContainer>
                        </ItemBoxTwoStyled>
                    </ItemContainerStyled>
                </CategoryContainerStyled>
                
            </MainCategoryContainerStyled>
        )
    }
}

const TeaStyled = styled.div`
    display:flex;
    flex-direction: column;
    gap: 10px;

    span {
        font-size: 18px;
        font-weight: bold;
    }
`

const TeaArStyled = styled.div`
    display:flex;
    flex-direction: column;
    gap: 10px;
    text-align: right;

    span {
        font-size: 18px;
        font-weight: bold;
    }
`

export default AddOnsGrid;